import React from 'react';
import FeaturedAd from 'partial/FeaturedAd';
import { Row } from 'components/Containers/Row/Row';
import { Disclaimer } from 'components/AdvertiserToolTip/AdvertiserToolTip';

const FeaturedAdModule = props => {
  let showDisclaimer = props.showDisclaimer;

  if (
    props.offers.length === 1 &&
    props.offers.filter(x => x.location === 'DASHBOARD').length > 0
  ) {
    showDisclaimer = false;
  }
  return (
    <>
      {showDisclaimer && (
        <Row fullWidth>
          <Disclaimer showPartnerText />
        </Row>
      )}
      {props.offers.map((m, k) => {
        if (m.offerType === 'FEATURED_AD') {
          return (
            <FeaturedAd
              key={k}
              location={m.location}
              position={m.position}
              modulePosition={props.modulePosition}
              tagText={m.tagText}
              featuredAd={m.featuredAd}
              {...props}
            />
          );
        } else {
          return '';
        }
      })}
    </>
  );
};

FeaturedAdModule.defaultProps = {
  showDisclaimer: true,
};

export default FeaturedAdModule;
